module.exports = "\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/file-upload/fileUpload.component.html
// module id = 1262
// module chunks = 10